import React from 'react';
import { useTranslation } from 'react-i18next';
import IdentityCard from './IdentityCard';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 15,
      paddingRight: 15,
      marginTop: 20
    },
    [theme.breakpoints.up('xs')]: {
      marginTop: 20,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up(500)]: {
      marginTop: 40,
      paddingLeft: 15,
      paddingRight: 15
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 40,
      paddingLeft: 12,
      paddingRight: 12
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: 40,
      paddingLeft: 33,
      paddingRight: 33
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: 40,
      paddingLeft: 80,
      paddingRight: 80
    }
  }
}));

const IdentitiesList = (props) => {
  const { identities } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Grid container className={classes.mainContainer} direction='column'>
      {identities && identities.length ? (
        <>
          {
            <Grid container direction='row' item xs={12} md={10} >
              {identities.map((identity) => (
                <Grid item key={identity.userId} xs={12} md={12}>
                  <IdentityCard identity={identity} />
                </Grid>
              ))}
            </Grid>
          }
          <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 8 }}>
            {t('identityListView:noMoreData')}
          </div>
        </>
      )
        : (<h1>{t('identityListView:noIdentity')}</h1>)}
    </Grid>
  );
};

export default IdentitiesList;
